<div class="pt-12">
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "paymentInfo.paymentInformation" | translate }}
  </span>
</div>
<!-- Payment method -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.ReceiptPaymentTypeId)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.paymentMethod" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.receiptPaymentType"
        [disabled]="true"
        pInputText
        type="text"
        [ngClass]="getInputClass(false, false) + ' w-full'"
        [placeholder]="'paymentInfo.paymentMethodPlaceholder' | translate"
        (ngModelChange)="onPaymentMethodChange()" />
    </div>
  </div>
</div>
<!--Payment owner-->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.AccountOwner)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.paymentOwner" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.owner"
        [disabled]="!getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.AccountOwner, hasEndorsementWait4Sign)"
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            paymentOwnerHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.AccountOwner, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        [placeholder]="'paymentInfo.paymentOwnerPlaceholder' | translate"
        (ngModelChange)="onPaymentOwnerChange()" />
    </div>
  </div>
</div>
<!-- Payment fractionation -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.FractionationTypeId) &&
    policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel !== FractionationTypesLabel.Quarterly
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.paymentFraction" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="fractionationOptions"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.FractionationTypeId, hasEndorsementWait4Sign)
        "
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel"
        appendTo="body"
        [styleClass]="
          getDropdownClass(
            paymentFractionationHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.FractionationTypeId, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onPaymentFractionationChange()"
        [placeholder]="'generalOptions.placeholder' | translate"
        optionLabel="label"
        optionValue="code"></p-dropdown>
    </div>
  </div>
</div>
<!-- Payment Day Trimestriel -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.FractionationTypeId) &&
    policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel === FractionationTypesLabel.Quarterly
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.paymentFraction" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel"
        [disabled]="true"
        pInputText
        type="text"
        class="disabled-inputtext w-full"
        [placeholder]="'generalOptions.placeholder' | translate" />
    </div>
  </div>
</div>

<!-- Payment Day -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.CollectionDate) &&
    policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel !== FractionationTypesLabel.Annual
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.paymentDate" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="paymentDateOptions"
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.withdrawalDay"
        [disabled]="!getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.CollectionDate, hasEndorsementWait4Sign)"
        appendTo="body"
        [styleClass]="
          getDropdownClass(
            paymentCollectionDateHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.CollectionDate, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onPaymentCollectionDateChange()"
        optionLabel="label"
        optionValue="value"></p-dropdown>
    </div>
  </div>
</div>
<!-- Payment iban -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.BANK, Bank.Iban)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "paymentInfo.iban" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-inputMask
        #iban
        [(ngModel)]="policyDetailsCopy.bankInformationPolicyVm.iban"
        class="w-full"
        [autoClear]="false"
        [unmask]="true"
        [disabled]="!getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.Iban, hasEndorsementWait4Sign)"
        [ngClass]="
          getInputMaskClass(
            paymentIbanHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.BANK, Bank.Iban, hasEndorsementWait4Sign),
            isIbanValid
          ) + ' w-full'
        "
        mask="**** **** **** **** **** **** ***"
        (ngModelChange)="onPaymentIbanChange()"
        (onBlur)="onPaymentIbanBlur()">
      </p-inputMask>
      <div class="w-full mt-1">
        <span
          *ngIf="!isIbanValid"
          class="error-message text-xs">
          {{ "paymentInfo.ibanErrorTitle" | translate }}
        </span>
        <span
          *ngIf="paymentIbanHasChanged && isIbanValid"
          class="success-message text-xs">
          {{ "paymentInfo.ibanSuccessTitle" | translate }}
        </span>
      </div>
    </div>
  </div>
</div>

